var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F1F5FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.04532 6.60307L9.25001 15.8617C9.38672 16.2609 9.95547 16.2499 10.0813 15.8453L11.3719 11.6562C11.3914 11.5877 11.4283 11.5255 11.4791 11.4756C11.53 11.4258 11.5929 11.39 11.6617 11.3718L15.8453 10.0812C16.25 9.95541 16.2609 9.38666 15.8617 9.24994L6.60313 6.04526C6.52534 6.01792 6.44141 6.01312 6.36101 6.03141C6.28061 6.0497 6.20701 6.09034 6.14871 6.14865C6.09041 6.20695 6.04976 6.28055 6.03147 6.36095C6.01318 6.44135 6.01798 6.52528 6.04532 6.60307V6.60307Z",
    stroke: "#1C86F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav);
export default __webpack_public_path__ + "static/media/nav.737e969cef16177cf4e6ef13248b2409.svg";
export { ForwardRef as ReactComponent };